module.exports = __webpack_public_path__ + "assets/img/earth-min2.5af39c61.png";